// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2bANQ","content":"styles_content__v12Fi","selectAll":"styles_selectAll__gsaFH"};